var userConfig = {
  computed: {
    userConfig() {
      return this.$store.getters["user/config"];
    }
  }
};

export default userConfig;
